import { useQuery } from '@tanstack/react-query'
import type { components } from '../api/generated/schema'
import { keys } from '../api/keys'
import type { AsyncState } from '../platform/async/Async'
import { fromQuery } from '../platform/async/fromQuery'
import { loadProfile } from './session'

export type Profile = components['schemas']['UserResponse']

/**
 * The current-user query, read through a selector. Every consumer shares the
 * `keys.user.me()` cache entry, so two of them cause one fetch.
 */
export function useProfileState<T>(select: (p: Profile) => T, message: string): AsyncState<T> {
  const query = useQuery({ queryKey: keys.user.me(), queryFn: loadProfile, select })
  return fromQuery(query, {
    message: () => message,
    recovery: { label: 'Try again', onAct: () => void query.refetch() },
  })
}

/**
 * The profile or `undefined`, for chrome that must not render an `<Async>` —
 * the top-bar avatar falls back to the email until this arrives.
 */
export function useProfileValue(): Profile | undefined {
  return useQuery({ queryKey: keys.user.me(), queryFn: loadProfile }).data
}
